module.exports = __webpack_public_path__ + "dc3c0e70f027903f5d57e9c31391d11e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-18.png
// module id = 1598
// module chunks = 0